import { useCallback, useState, useMemo } from 'react';
import { each } from 'underscore';
import { MaxAddAssetJobInParell } from '@bingads-webui-campaign-react/ads-studio-app-shared-components';
import { runJobsInParallelWithRateLimit } from '@bingads-webui-universal/parallel-job-with-rate-limit';

export const useSourceVideos = ({
  dataService, logger, navigation, perfMarker,
}) => {
  const [selectedVideos, setSelectedVideos] = useState([]);
  const [showBlocker, setShowBlocker] = useState(false);
  const validInvestVideos = useMemo(() => (Array.isArray(selectedVideos) ? selectedVideos.filter(({ id }) => !!id) : []), [selectedVideos]);
  const validUrlVideos = useMemo(() => (Array.isArray(selectedVideos) ? selectedVideos.filter(({ url }) => !!url) : []), [selectedVideos]);

  const onInvestClickSelect = useCallback((handleJobErrors) => {
    const investVideoPerfMarker = perfMarker && perfMarker.createChild('investVideoPicker');
    if (investVideoPerfMarker) {
      investVideoPerfMarker.willInit();
    }
    const jobErrors = [];
    const handleJobError = (err) => {
      jobErrors.push(err);
    };

    const saveOperations = [];

    each(validInvestVideos, ({ id, url, description }) => {
      saveOperations.push(() => dataService.uploadInvestVideo({ investVideoId: id, videoSrc: url, description }));
    });

    setShowBlocker(true);
    runJobsInParallelWithRateLimit({
      jobsToRateLimit: saveOperations,
      maxJobsInParallel: MaxAddAssetJobInParell,
      handleJobError,
    }).then((values) => {
      const videoIds = values || [];
      logger.logTrace('Add Media Panel: saved invest videos to folder', { videoIds: videoIds.join(','), count: videoIds.length });
      navigation.goBack({ reload: true });
    }).finally(() => {
      setSelectedVideos([]);
      handleJobErrors(jobErrors);
      setShowBlocker(false);
      if (investVideoPerfMarker) {
        investVideoPerfMarker.done();
      }
    });
  }, [dataService, logger, navigation, validInvestVideos]);

  const onUrlClickSelect = useCallback((handleJobErrors) => {
    const addVideoUrlPerfMarker = perfMarker && perfMarker.createChild('addVideoUrl');
    if (addVideoUrlPerfMarker) {
      addVideoUrlPerfMarker.willInit();
    }
    const jobErrors = [];
    const handleJobError = (err) => {
      jobErrors.push(err);
    };

    const saveOperations = [];

    each(validUrlVideos, ({ url }) => {
      saveOperations.push(() => dataService.uploadVideoByUrl({ videoUrl: url }));
    });

    setShowBlocker(true);
    runJobsInParallelWithRateLimit({
      jobsToRateLimit: saveOperations,
      maxJobsInParallel: MaxAddAssetJobInParell,
      handleJobError,
    }).then((values) => {
      const videoIds = values || [];
      logger.logTrace('Add Media Panel: saved videos to folder', { videoIds: videoIds.join(','), count: videoIds.length });
      navigation.goBack({ reload: true });
    }).finally(() => {
      setSelectedVideos([]);
      handleJobErrors(jobErrors);
      setShowBlocker(false);
      if (addVideoUrlPerfMarker) {
        addVideoUrlPerfMarker.done();
      }
    });
  }, [dataService, logger, navigation, validUrlVideos]);

  return {
    selectedVideos,
    showBlocker,
    setSelectedVideos,
    onInvestClickSelect,
    onUrlClickSelect,
  };
};
